
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/ocean-technology/products/coastal-and-marine-environmental-monitoring-software",
      function () {
        return require("private-next-pages/industries/ocean-technology/products/coastal-and-marine-environmental-monitoring-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/ocean-technology/products/coastal-and-marine-environmental-monitoring-software"])
      });
    }
  